export const GET_LITE_TRADE_TOKEN_ACTION = 'GET_LITE_TRADE_TOKEN_ACTION';
export const GET_LITE_TRADE_TOKEN_SUCCESS = 'GET_LITE_TRADE_TOKEN_SUCCESS';
export const GET_LITE_TRADE_TOKEN_FAILURE = 'GET_LITE_TRADE_TOKEN_FAILURE';

export const INIT_LITE_TRADE_ACTION = 'INIT_LITE_TRADE_ACTION';
export const INIT_LITE_TRADE_SUCCESS = 'INIT_LITE_TRADE_SUCCESS';
export const INIT_LITE_TRADE_FAILURE = 'INIT_LITE_TRADE_FAILURE';

export const PING_LITE_TRADE_ACTION = 'PING_LITE_TRADE_ACTION';
export const PING_LITE_TRADE_SUCCESS = 'PING_LITE_TRADE_SUCCESS';
export const PING_LITE_TRADE_FAILURE = 'PING_LITE_TRADE_FAILURE';

export const LOGIN_LITE_TRADE_ACTION = 'LOGIN_LITE_TRADE_ACTION';
export const LOGIN_LITE_TRADE_SUCCESS = 'LOGIN_LITE_TRADE_SUCCESS';
export const LOGIN_LITE_TRADE_FAILURE = 'LOGIN_LITE_TRADE_FAILURE';

export const LOGOUT_LITE_TRADE_ACTION = 'LOGOUT_LITE_TRADE_ACTION';
export const LOGOUT_LITE_TRADE_SUCCESS = 'LOGOUT_LITE_TRADE_SUCCESS';
export const LOGOUT_LITE_TRADE_FAILURE = 'LOGOUT_LITE_TRADE_FAILURE';

export const ADD_LITE_TRADE_SUBSCRIPTION = 'ADD_LITE_TRADE_SUBSCRIPTION';

export const REMOVE_LITE_TRADE_SUBSCRIPTION = 'REMOVE_LITE_TRADE_SUBSCRIPTION';

export const SET_LITE_TRADE_ACCOUNT_METRICS = 'SET_LITE_TRADE_ACCOUNT_METRICS';
export const SET_LITE_TRADE_ACCOUNT_PORTFOLIO = 'SET_LITE_TRADE_ACCOUNT_PORTFOLIO';

export const GET_LITE_TRADE_ASSETS_ACTION = 'GET_LITE_TRADE_ASSETS_ACTION';
export const GET_LITE_TRADE_ASSETS_SUCCESS = 'GET_LITE_TRADE_ASSETS_SUCCESS';
export const GET_LITE_TRADE_ASSETS_FAILURE = 'GET_LITE_TRADE_ASSETS_FAILURE';

export const PROCESS_LITE_TRADE_POSITION_NOTIFICATION = 'PROCESS_LITE_TRADE_POSITION_NOTIFICATION';
export const PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION = 'PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION';
export const PROCESS_LITE_TRADE_ORDER_NOTIFICATION = 'PROCESS_LITE_TRADE_ORDER_NOTIFICATION';

/**
 * @deprecated use OPEN_LITE_TRADE_POSITION_ACTION/CLOSE_LITE_TRADE_POSITION_ACTION
 */
export const CREATE_LITE_TRADE_ORDER_ACTION = 'CREATE_LITE_TRADE_ORDER_ACTION';
export const CREATE_LITE_TRADE_ORDER_SUCCESS = 'CREATE_LITE_TRADE_ORDER_SUCCESS';
export const CREATE_LITE_TRADE_ORDER_FAILURE = 'CREATE_LITE_TRADE_ORDER_FAILURE';

export const OPEN_LITE_TRADE_POSITION_ACTION = 'OPEN_LITE_TRADE_POSITION_ACTION';
export const OPEN_LITE_TRADE_POSITION_SUCCESS = 'OPEN_LITE_TRADE_POSITION_SUCCESS';
export const OPEN_LITE_TRADE_POSITION_FAILURE = 'OPEN_LITE_TRADE_POSITION_FAILURE';

export const UPDATE_LITE_TRADE_ORDER_ACTION = 'UPDATE_LITE_TRADE_ORDER_ACTION';
export const UPDATE_LITE_TRADE_ORDER_SUCCESS = 'UPDATE_LITE_TRADE_ORDER_SUCCESS';
export const UPDATE_LITE_TRADE_ORDER_FAILURE = 'UPDATE_LITE_TRADE_ORDER_FAILURE';

export const UPDATE_LITE_TRADE_POSITION_ACTION = 'UPDATE_LITE_TRADE_POSITION_ACTION';
export const UPDATE_LITE_TRADE_POSITION_SUCCESS = 'UPDATE_LITE_TRADE_POSITION_SUCCESS';
export const UPDATE_LITE_TRADE_POSITION_FAILURE = 'UPDATE_LITE_TRADE_POSITION_FAILURE';

export const CLOSE_LITE_TRADE_POSITION_ACTION = 'CLOSE_LITE_TRADE_POSITION_ACTION';
export const CLOSE_LITE_TRADE_POSITION_SUCCESS = 'CLOSE_LITE_TRADE_POSITION_SUCCESS';
export const CLOSE_LITE_TRADE_POSITION_FAILURE = 'CLOSE_LITE_TRADE_POSITION_FAILURE';

export const CANCEL_LITE_TRADE_ORDER_ACTION = 'CANCEL_LITE_TRADE_ORDER_ACTION';
export const CANCEL_LITE_TRADE_ORDER_SUCCESS = 'CANCEL_LITE_TRADE_ORDER_SUCCESS';
export const CANCEL_LITE_TRADE_ORDER_FAILURE = 'CANCEL_LITE_TRADE_ORDER_FAILURE';

export const UPDATE_MARKET_DATA = 'UPDATE_MARKET_DATA'; // Note that this action has been hidden in console by middleware
export const UPDATE_MARKET_DATA_CANDLE = 'UPDATE_MARKET_DATA_CANDLE'; // Note that this action has been hidden in console by middleware

export const ADD_MARKET_DATA_WATCH_ACTION = 'ADD_MARKET_DATA_WATCH_ACTION';
export const REMOVE_MARKET_DATA_WATCH_ACTION = 'REMOVE_MARKET_DATA_WATCH_ACTION';

export const ADD_MARKET_DATA_CANDLE_WATCH_ACTION = 'ADD_MARKET_DATA_CANDLE_WATCH_ACTION';
export const REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION = 'REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION';

export const GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION = 'GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION';
export const GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS = 'GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS';
export const GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE = 'GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE';

export const LITE_TRADE_ORDER_STATUSES = {
    CANCELED: 'CANCELED',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED',
    WORKING: 'WORKING',
}

export const LITE_TRADE_ACCOUNT_EVENT_TYPES = {
    LIQUIDATION: 'LIQUIDATION',
    MARGIN_CALL: 'MARGIN_CALL',
}

export const LITE_TRADE_POSITION_EFFECTS = {
    CLOSE: 'CLOSE',
    OPEN: 'OPEN',
}

// Порядок важен для отоюбражения! Сначала Sell!
export const LITE_TRADE_POSITION_SIDE = {
    SELL: 'SELL',
    BUY: 'BUY',
}

export const LITE_TRADE_DX_REJECT_CODES = {
    NOT_ENOUGH_SPACE: 'not_enough_space',
    TRADING_HOURS: 'trading_hours',
}

// dx doesnt send some reject id, we have to parse text
export const MAP_LITE_TRADE_DX_REJECT_SUBSTRING_TO_REJECT_CODE = {
    'Your margin is insufficient': LITE_TRADE_DX_REJECT_CODES.NOT_ENOUGH_SPACE,
    'is currently off trading hours': LITE_TRADE_DX_REJECT_CODES.TRADING_HOURS,
}

export const LITE_TRADE_ORDER_LINK_TYPES = {
    CHILD: 'CHILD',
    PARENT: 'PARENT',
}

export const LITE_TRADE_PRICE_SIDE = {
    ASK: 'ask',
    BID: 'bid',
}

export const PRESET_STAT_PL = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    ALL: 'all',
}
